var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-item"},[_c('img',{attrs:{"src":require("../images/nowTime.png"),"alt":""}}),_c('span',{staticClass:"nowTime fz-18"},[_vm._v(_vm._s(_vm.nowTimes))])])
}
var staticRenderFns = []

export { render, staticRenderFns }